import React from 'react';

/**
  * AuroraBackground - A subtle animated gradient background effect
  * Uses purple (#7C3AED) and orange (#F97316) brand colors
  * Creates a soft, flowing aurora-like wave animation
  */
const AuroraBackground: React.FC = () => {
    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: '#FFFFFF',
                    zIndex: -2,
                }}
            />
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflow: 'hidden',
                    zIndex: -1,
                    pointerEvents: 'none',
                }}
            >
                {/* Primary purple wave */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-50%',
                        left: '-50%',
                        width: '200%',
                        height: '200%',
                        background: `
                            radial-gradient(
                                ellipse 80% 50% at 20% 40%,
                                rgba(124, 58, 237, 0.18) 0%,
                                transparent 50%
                            )
                        `,
                        animation: 'auroraWave1 20s ease-in-out infinite',
                    }}
                />

                {/* Secondary orange wave */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-50%',
                        left: '-50%',
                        width: '200%',
                        height: '200%',
                        background: `
                            radial-gradient(
                                ellipse 70% 60% at 80% 60%,
                                rgba(249, 115, 22, 0.15) 0%,
                                transparent 50%
                            )
                        `,
                        animation: 'auroraWave2 25s ease-in-out infinite',
                    }}
                />

                {/* Tertiary purple accent */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-50%',
                        left: '-50%',
                        width: '200%',
                        height: '200%',
                        background: `
                            radial-gradient(
                                ellipse 60% 40% at 60% 30%,
                                rgba(124, 58, 237, 0.12) 0%,
                                transparent 45%
                            )
                        `,
                        animation: 'auroraWave3 30s ease-in-out infinite',
                    }}
                />

                {/* Subtle orange accent */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-50%',
                        left: '-50%',
                        width: '200%',
                        height: '200%',
                        background: `
                            radial-gradient(
                                ellipse 50% 70% at 30% 70%,
                                rgba(249, 115, 22, 0.10) 0%,
                                transparent 40%
                            )
                        `,
                        animation: 'auroraWave4 22s ease-in-out infinite',
                    }}
                />
            </div>

            <style>
                {`
                    @keyframes auroraWave1 {
                        0%, 100% {
                            transform: translate(0%, 0%) rotate(0deg);
                        }
                        25% {
                            transform: translate(5%, 3%) rotate(2deg);
                        }
                        50% {
                            transform: translate(2%, 5%) rotate(-1deg);
                        }
                        75% {
                            transform: translate(-3%, 2%) rotate(1deg);
                        }
                    }

                    @keyframes auroraWave2 {
                        0%, 100% {
                            transform: translate(0%, 0%) rotate(0deg);
                        }
                        25% {
                            transform: translate(-4%, 2%) rotate(-2deg);
                        }
                        50% {
                            transform: translate(-2%, -4%) rotate(1deg);
                        }
                        75% {
                            transform: translate(3%, -2%) rotate(-1deg);
                        }
                    }

                    @keyframes auroraWave3 {
                        0%, 100% {
                            transform: translate(0%, 0%) scale(1);
                        }
                        33% {
                            transform: translate(3%, -3%) scale(1.05);
                        }
                        66% {
                            transform: translate(-2%, 4%) scale(0.98);
                        }
                    }

                    @keyframes auroraWave4 {
                        0%, 100% {
                            transform: translate(0%, 0%) scale(1);
                        }
                        40% {
                            transform: translate(-5%, 3%) scale(1.02);
                        }
                        70% {
                            transform: translate(4%, -2%) scale(0.97);
                        }
                    }
                `}
            </style>
        </>
    );
};

export default AuroraBackground;
